export const RECEIVE_POWER_TRANSFORMER_POWERS =
  'RECEIVE_POWER_TRANSFORMER_POWERS';
export const GET_POWER_TRANSFORMER_POWERS = 'GET_POWER_TRANSFORMER_POWERS';
export const SET_POWER_TRANSFORMER_POWER = 'SET_POWER_TRANSFORMER_POWER';
export const UPDATE_POWER_TRANSFORMER_POWER = 'UPDATE_POWER_TRANSFORMER_POWER';
export const DELETE_POWER_TRANSFORMER_POWER = 'DELETE_POWER_TRANSFORMER_POWER';
export const FETCH_POWER_TRANSFORMER_POWERS = 'FETCH_POWER_TRANSFORMER_POWERS';
